import { createContext } from "react";

const UserStore = createContext(null);

export default UserStore;